// plugins/aiolos.client.ts
declare global {
  interface Window {
    bbAnalysis?: {
      init: (config: Record<string, unknown>) => void;
    };
  }
}

export default defineNuxtPlugin(() => {
  const aiolosConfig = {
    appKey: "5D436B747CDF41C39E6CF83EEE02BDAF", //经分appKey
    appName: "创意世界-跃次元官网", //app包名
    autoGetOpenID: true,
    chCode: "h5", //业务渠道代码
    platform: 71, //平台类型 0站点 1iPhone 2iPad 11Android 12安卓平板 21微信小程序 22快应用 23百度小程序/小游戏 24QQ小程序 25字节小程序/小游戏 26钉钉小程序 27钉钉PC 28oppo小游戏 29vivo小游戏 30微信小游戏 31oppo海外小游戏 32快手小程序/小游戏 33支付宝小程序 50音箱 51电视 52车载 53手表 60Google 61Google平板 70微信公众号 71H5 80鸿蒙 101点读笔
    platform2: 18, //经分平台类型 1ios 2android 3google 4微信小程序 5微信小游戏 6百度小程序/小游戏 7字节小程序/小游戏 8oppo小游戏 9vivo小游戏 10音箱 11电视 12车载 13快应用 14鸿蒙 15钉钉小程序 16钉钉PC 17微信公众号 18H5 19oppo海外小游戏 20快手小程序/小游戏 21手表 24QQ小程序 25支付宝小程序 26点读笔
    productID: 2642, //产品标识(区分业务请求还是分析请求)
    projectID: 557, //项目标识
    verCode: "1.00.00", //业务版本代码
    verID: "10000", //业务版本标识
    isDebugMode: false, //是否开启前端调试模式，可选，默认false
  };

  const start = Date.now();
  const timer = setInterval(() => {
    if (window.bbAnalysis) {
      clearInterval(timer);
      // 执行初始化
      window.bbAnalysis.init(aiolosConfig);
    } else if (Date.now() - start > 10000) {
      clearInterval(timer);
      console.error("bbAnalysis 加载超时");
    }
  }, 50);
});
